import { Button, Card, Col, Modal, Row } from 'antd';
import dayjs from 'dayjs';
import FileViewer from 'features/new-clients/components/clients-details/file-viewer';
import { Fragment, useState } from 'react';
import { formatUtcToLocal } from 'routes/utils';
// handleDownload
type SubTableProps = {
  dataList: any;
  isRoleListLoading: boolean;
};

export const ManagementItemView = ({
  dataList,
}: // isRoleListLoading,
SubTableProps) => {
  const [selectedDate] = useState<dayjs.Dayjs | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [iframeSrc, setIframeSrc] = useState<string | null>(null);
  const [imageSrc, setImageSrc] = useState<string>('');
  const filteredDataList = selectedDate
    ? dataList?.rc?.filter((item: any) =>
        dayjs(item?.lastUpdatedDate).isSame(selectedDate, 'month'),
      )
    : dataList?.rc;
  const handleOpenModal = (item: any) => {
    const fileExtension = item?.documentPath?.split('.').pop();
    // Check if the file is an image
    if (
      ['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(
        fileExtension?.toLowerCase() || '',
      )
    ) {
      setImageSrc(item?.documentPath); // Set image source for image files
      setIframeSrc(''); // Clear iframe source if it's an image
    } else {
      // If it's not an image, assume it's a document and open it in iframe
      setIframeSrc(
        `https://docs.google.com/gview?url=${item?.documentPath}&embedded=true`,
      );
      setImageSrc(''); // Clear image source if it's a document
    }

    setIsModalVisible(true);
  };
  const handleCloseModal = () => {
    setIsModalVisible(false);
    setIframeSrc(null);
  };

  return (
    <Fragment>
      {/* bg-white p-4 rounded-lg */}
      <div className=''>
        <div className='mb-3 flex justify-between'>
          <h3 className='text-xl text-[#313030] font-semibold'>Documents</h3>
        </div>
        <Row gutter={[16, 16]}>
          {/* Render filtered data */}
          {filteredDataList?.map((item: any, index: number) => (
            <Col xxl={6} xl={8} lg={8} md={12} sm={24} key={index}>
              <Card
                role='button'
                className='bg-[#F6F7F9] lgl_crd border-0'
                style={{ width: '100%', position: 'relative' }}
                bodyStyle={{ padding: '16px' }}
              >
                <div className='flex gap-3 items-start	'>
                  <div>
                    <div className='bg-white p-2 rounded-xl relative'>
                      <figure className='mediafolder'>
                        <FileViewer documentPath={item.documentPath} />
                      </figure>
                    </div>
                  </div>

                  <div className='flex flex-col grow'>
                    <p className='font-bold'>{item?.documentName}</p>
                    <p>
                      <span className='font-bold'>Note:</span>
                      {item?.note}
                    </p>
                    <p>{item?.documentSize}</p>
                    <p className='text-xs text-gray-500'>
                      {/* {dayjs(item?.lastUpdatedDate).format('DD-MMM-YYYY')} */}
                      {formatUtcToLocal(
                        dayjs(item?.lastUpdatedDate).format('DD-MMM-YYYY'),
                      )}
                    </p>
                    {/* Wrap the DownloadOutlined icon inside an anchor tag for downloading the image */}

                    <div
                      className='flex mt-3'
                      style={{ justifyContent: 'end' }}
                    >
                      {/* <Button
                        className='bg-blue-900 text-white border-none text-xs btn-sm p-2 hover:bg-blue-950 hover:text-white mr-3 rounded'
                        onClick={() => handleDownload(item.documentPath)}
                      >
                        <span>Download</span>
                      </Button> */}
                      <Button
                        onClick={() => handleOpenModal(item)} // Correctly pass `item` to the function
                        className='border-blue-900 bg-white border-solid border text-xs btn-sm p-2 hover:bg-white hover:text-blue-900 rounded cursor-pointer'
                      >
                        <span>Preview</span>
                      </Button>
                    </div>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
        <Modal
          title='File Viewer'
          visible={isModalVisible}
          onCancel={handleCloseModal}
          footer={null}
          width='80%'
          style={{ top: 20, maxWidth: '500px' }}
          maskClosable={false}
        >
          {/* Show iframe for documents or image for images */}
          {iframeSrc ? (
            <iframe
              src={iframeSrc}
              title='File Preview'
              width='100%'
              height='450px'
              frameBorder='0'
            />
          ) : imageSrc ? (
            <img src={imageSrc} alt='File Preview' style={{ width: '100%' }} />
          ) : (
            <div>No preview available</div>
          )}
        </Modal>
      </div>
    </Fragment>
  );
};
